"use client";

import { useCallback, useState } from "react";

import Text from "./Text";
import { Hexagon as HexagonType } from "./index";
const logoEhealth =
  "/images/IndexPage/Technology/images/white-logo-ehealth.png";
const logoSignoWise =
  "/images/IndexPage/Technology/images/white-logo-signo-wise.png";
const graboxy = "/images/IndexPage/Technology/images/graboxy.svg";
const texts = new Proxy({"BaseText":"BaseText-2ad47","Biometrics":"Biometrics-2ad47","Neurology":"Neurology-2ad47","Cybersecurity":"Cybersecurity-2ad47","CybersecurityHover":"CybersecurityHover-2ad47","NeurologyHover":"NeurologyHover-2ad47","BiometricsHover":"BiometricsHover-2ad47"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
const strings = new Proxy({"BaseString":"BaseString-57db3","Biometrics":"Biometrics-57db3","String12":"String12-57db3","String11":"String11-57db3","String10":"String10-57db3","String9":"String9-57db3","String8":"String8-57db3","Neurology":"Neurology-57db3","String7":"String7-57db3","String6":"String6-57db3","Cybersecurity":"Cybersecurity-57db3","String5":"String5-57db3","String4":"String4-57db3","String3":"String3-57db3","String2":"String2-57db3","String1":"String1-57db3"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
const hexagonStyles = new Proxy({"Hexagons":"Hexagons-cb406","BaseHexagon":"BaseHexagon-cb406","Hexagon8":"Hexagon8-cb406","Hexagon7":"Hexagon7-cb406","Hexagon6":"Hexagon6-cb406","Hexagon5":"Hexagon5-cb406","Hexagon4":"Hexagon4-cb406","Hexagon3":"Hexagon3-cb406","Hexagon2":"Hexagon2-cb406","Hexagon1":"Hexagon1-cb406","Cybersecurity":"Cybersecurity-cb406","Biometrics":"Biometrics-cb406"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import Hexagon from "./Hexagon";

const TEXTS = [
  {
    title: "Cybersecurity",
  },
  {
    title: "Video Analysis",
  },
  {
    title: "Biometrics",
  },
];

const STRINGS = [
  { className: strings.String1 },
  { className: strings.String2 },
  { className: strings.String3 },
  { className: strings.String4 },
  { className: strings.String5 },

  { className: strings.String6 },
  { className: strings.String7 },

  { className: strings.String8 },
  { className: strings.String9 },
  { className: strings.String10 },
  { className: strings.String11 },
  { className: strings.String12 },
];

const HEXAGONS: HexagonType[] = [
  {
    to: "https://graboxy.com",
    title: "Continuous Authentication",
    image: { url: graboxy, width: 163, height: 37 },
  },
  {
    to: "https://graboxy.com",
    title: "Blocking Spam Traffic",
    image: { url: graboxy, width: 163, height: 37 },
  },
  {
    to: "https://graboxy.com",
    title: "Remote Desktop Detection",
    image: { url: graboxy, width: 163, height: 37 },
  },
  {
    to: "https://graboxy.com",
    title: "Multi-Factor Authentication",
    image: { url: graboxy, width: 163, height: 37 },
  },
  {
    to: "/walking-recognition",
    title: "Walking Recognition",
  },
  {
    to: "/MotionAnalysisHealth",
    title: "Clinical Diagnostics",
    image: { url: logoEhealth, width: 32, height: 19 },
  },
  {
    to: "/sensor-and-video-analysis",
    title: "3D Movement Analysis",
  },
  {
    to: "https://signowise.com",
    title: "Biometric e-Signatures",
    image: { url: logoSignoWise, width: 112, height: 19 },
  },
];

const Hexagons = ({
  hexagons,
  groupNames,
}: {
  hexagons?: HexagonType[];
  groupNames?: { title: string }[];
}) => {
  const [idx, setIdx] = useState(0);

  const onMouse = useCallback(
    (idx: any) => {
      setIdx(idx);
    },
    [setIdx],
  );

  const renderedStrings = STRINGS.map((string, i) => (
    <div key={i} {...string} />
  ));

  const usedHexagons = hexagons?.length === 8 ? hexagons : HEXAGONS;
  const renderedHexagons = usedHexagons.map((hexagon, idx) => (
    <Hexagon key={idx} idx={idx + 1} {...hexagon} onMouse={onMouse} />
  ));

  const usedTexts = groupNames?.length ? groupNames : TEXTS;

  const renderedTexts = usedTexts.map(({ title }, i) => {
    const classes = [
      i === 0
        ? texts.Cybersecurity
        : i === 1
          ? texts.Neurology
          : texts.Biometrics,
      0 < idx && idx <= 4 && texts.CybersecurityHover,
      idx === 5 && texts.NeurologyHover,
      6 <= idx && texts.BiometricsHover,
    ].join(" ");

    return (
      <Text key={i} className={classes}>
        {title}
      </Text>
    );
  });

  return (
    <div className={hexagonStyles.Hexagons}>
      {renderedTexts}
      {renderedStrings}
      {renderedHexagons}
    </div>
  );
};

export default Hexagons;
